const accountObject = {
  id: 'myaccount',
  index: 0,
  parent: null,
  url: '/cart/consultancy',
  icon: 'person',
  children: [
    {
      id: 'consultData',
      index: 1,
      url: '/consultData',
      children: [],
      icon: 'badge',
      country: 'MX',
    },
    {
      id: 'consultData',
      index: 1,
      url: '/consultDataUS',
      children: [],
      icon: 'badge',
      country: 'US',
    },
    {
      id: 'changePassword',
      index: 1,
      url: '/ChangePassword',
      children: [],
      icon: 'password',
    },
    {
      id: 'accountstatus',
      index: 1,
      url: '/accountstatus',
      children: [],
      icon: 'receipt_long',
    },
    {
      id: 'invoices',
      index: 1,
      url: '/invoices',
      children: [],
      icon: 'download',
      country: 'MX',
    },
    {
      id: 'catalogsus',
      index: 1,
      url: '/catalogsus',
      children: [],
      icon: 'menu_book',
      country: 'US',
    },
    {
      id: 'catalogsmx',
      index: 1,
      url: '/catalogsmx',
      children: [],
      icon: 'menu_book',
      country: 'MX',
    },
    {
      id: 'myOrders',
      index: 1,
      url: '/myOrders',
      children: [],
      icon: 'local_shipping',
    },
    {
      id: 'reshipments',
      index: 1,
      url: '/reshipments',
      children: [],
      icon: 'replay',
    },
    {
      id: 'wallet',
      index: 1,
      url: 'https://tmbrands.mypayquicker.com',
      children: [],
      icon: 'account_balance_wallet',
      external: true,
      country: 'US',
    },
    {
      id: 'taxData',
      index: 1,
      url: '/taxData',
      children: [],
      icon: 'data_usage',
      country: 'MX',
    },
    {
      id: 'digitalOrders',
      index: 1,
      url: '/MyDigitalOrders',
      children: [],
      icon: 'list_alt',
      country: 'US',
    },
  ],
};

export default accountObject;
